import api from '~api'
import { convertCampusRecruitingIndexResponse } from '~utils/api'

export const url = (section) => `/home/${section}`
const newsType = [
  {
    color: 'pink',
    text: '實習資訊',
    bg: 'bg_first'
  },
  {
    color: 'yellow',
    text: '徵才快報',
    bg: 'bg_second'
  },
  {
    color: 'blue',
    text: '活動公告',
    bg: 'bg_third'
  },
  {
    color: 'green',
    text: '一般訊息',
    bg: 'bg_fourth'
  }
]

export async function getHomeBanners () {
  const {
    data
  } = await api.get(url('banner'), {
    params: {
      limit: 3
    }
  })

  const banners = data.data.map((banner, index) => {
    return {
      banner_id: banner.id,
      banner_image: banner.media.url || ''
    }
  })

  return banners
}

export async function getHomeNews () {
  const {
    data
  } = await api.get(url('news'))

  const news = data.data.map((pieceNews, index) => {
    return {
      news_id: pieceNews.id,
      news_published_at: pieceNews.start_date,
      news_type_color: newsType[pieceNews.type - 1].color,
      news_type_text: newsType[pieceNews.type - 1].text,
      news_type_bg: newsType[pieceNews.type - 1].bg,
      news_topic: pieceNews.title
    }
  })

  return news
}

export async function getHomeLinks () {
  const {
    data
  } = await api.get(url('link'), {
    params: {
      limit: 8
    }
  })

  const links = data.data.map((link, index) => {
    return {
      link_id: link.id,
      link_url: link.link.url,
      link_image: link.link.media.url
    }
  })

  return links
}

export async function gotHomeCampusRecruiting () {
  const {
    data
  } = await api.get(url('enlist-activity'), {
    params: {
      limit: 3
    }
  })

  const recruitments = data.data.map(recruitment => {
    return convertCampusRecruitingIndexResponse(recruitment)
  })

  return recruitments
}
